import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/nl';
import 'vue2-datepicker/locale/fr';
import 'vue2-datepicker/locale/es';
import moment from 'moment';

@Component({
  name: 'bpc-contact-birthdate-picker',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'date-picker': DatePicker,
  },
})

/**
 * This component has been created to be used in contact form instead of the datepicker component.
 * It's because the datepicker does not work with setter and getter with the relation contact - contact_individual,
 * so here we manage it with a watcher instead.
 */
export default class ContactBirthdatePicker extends mixins(AbstractField) {
  @Prop(String) readonly value: string;

  model = null;

  mounted() {
    this.setModelByValue();
  }

  setModelByValue() {
    this.model = this.value ? moment(this.value).toDate() : null;
  }

  @Watch('model', { deep: true })
  onModelChanged() {
    const value = this.model ? moment(this.model).format('YYYY-MM-DD') : null;
    this.$emit('input', value);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, value);
      });
    }
  }
}
